import React from 'react';

function Section(props) {
    return (
        <div className="mb-3 text-color-600 bg-gray-100 p-6 border-gray-200 border-b-4 rounded">
            {props.children}
        </div>
    );
}

export default Section;
